import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useState } from "react";

interface DummyQUestionProps {
  value: number | null;
  setValue: React.Dispatch<React.SetStateAction<number | null>>;
}

export const DummyQuestion: React.FC<DummyQUestionProps> = ({
  value,
  setValue,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(Number((event.target as HTMLInputElement).value));
  };

  return (
    <>
      <Box sx={{ padding: "1rem" }}>
        <Typography>これはダミーアンケートです。</Typography>
        <Typography>どれか一つを選択してください。</Typography>
      </Box>

      <Box sx={{ padding: "1rem" }}>
        <FormControl>
          <RadioGroup onChange={handleChange} value={value}>
            <FormControlLabel value={1} control={<Radio />} label="1" />
            <FormControlLabel value={2} control={<Radio />} label="2" />
            <FormControlLabel value={3} control={<Radio />} label="3" />
            <FormControlLabel value={4} control={<Radio />} label="4" />
            <FormControlLabel value={5} control={<Radio />} label="5" />
          </RadioGroup>
        </FormControl>
      </Box>
      {/* <Button onClick={() => console.log(value)}>Check</Button> */}
    </>
  );
};
